
export enum PublishingStatus {
  Unpublished = 'Unpublished',
  UnderReview = 'UnderReview',
  Published = 'Published',
  Rejected = 'Rejected'
}
